import React from 'react';
import Login from '../../components/Login/Login';

const FinanceLogin = () => {
  return <Login role="finance-partner" />;
};

export default FinanceLogin;
